'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Dialog = require('../../node_modules/@material-ui/core/esm/Dialog/Dialog.js');
var DialogTitle = require('../../node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js');
var DialogContent = require('../../node_modules/@material-ui/core/esm/DialogContent/DialogContent.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var DialogActions = require('../../node_modules/@material-ui/core/esm/DialogActions/DialogActions.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  dialogStyle: {
    minWidth: 200
  }
};
var ConfirmationDialog = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ConfirmationDialog, _PureComponent);

  function ConfirmationDialog() {
    classCallCheck(this, ConfirmationDialog);

    return possibleConstructorReturn(this, getPrototypeOf(ConfirmationDialog).apply(this, arguments));
  }

  createClass(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          message_title = _this$props.message_title,
          message_body = _this$props.message_body,
          onCancelClick = _this$props.onCancelClick,
          onConfirmClick = _this$props.onConfirmClick,
          cancelButtonMessage = _this$props.cancelButtonMessage,
          confirmButtonMessage = _this$props.confirmButtonMessage,
          confirmButtonColor = _this$props.confirmButtonColor,
          classes = _this$props.classes;
      return React__default["default"].createElement(Dialog["default"], {
        open: open,
        onClose: function onClose() {
          return onCancelClick();
        }
      }, React__default["default"].createElement(DialogTitle["default"], {
        className: classes.dialogStyle
      }, message_title), ObjectHelper.isPresent(message_body) && React__default["default"].createElement(DialogContent["default"], {
        className: classes.dialogContent
      }, React__default["default"].createElement(Typography["default"], {
        variant: "body1"
      }, message_body)), React__default["default"].createElement(DialogActions["default"], null, ObjectHelper.isPresent(onCancelClick) && React__default["default"].createElement(Button["default"], {
        onClick: function onClick() {
          return onCancelClick();
        }
      }, cancelButtonMessage), ObjectHelper.isPresent(onConfirmClick) && React__default["default"].createElement(Button["default"], {
        color: confirmButtonColor,
        onClick: function onClick(photo) {
          return onConfirmClick(photo);
        }
      }, confirmButtonMessage)));
    }
  }]);

  return ConfirmationDialog;
}(React.PureComponent)) || _class);
ConfirmationDialog.defaultProps = {
  open: false,
  message_title: 'Are you sure?',
  message_body: 'Are you sure about what you are about to do?',
  cancelButtonMessage: 'Cancel',
  confirmButtonMessage: 'Confirm',
  confirmButtonColor: 'primary'
};

module.exports = ConfirmationDialog;
